import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 px-5 pb-16 pt-14 sm:px-8 sm:pb-20 sm:pt-20" data-id="element-194" data-mp="eiv6gzbp9elw">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[-20rem] h-[38rem] w-[38rem] -translate-x-1/2 rounded-full bg-accent/20 blur-[150px]" data-id="element-195" data-mp="9llb731mq8q5" />

      <motion.div initial={{
      opacity: 0,
      y: 26
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mx-auto w-full max-w-4xl text-center" data-id="element-196" data-mp="12a0j75mcfqrz">
        <p className="flex items-center justify-center gap-4 text-[11px] font-bold uppercase tracking-[0.26em] text-accent-soft sm:text-xs" data-id="element-197" data-mp="s9ghy2ytqm9r">
          <span aria-hidden="true" className="hidden h-px w-10 bg-accent/50 sm:block" data-id="element-198" data-mp="3d1a4l90jrr80" />
          La guía completa para usuarios de iPhone
          <span aria-hidden="true" className="hidden h-px w-10 bg-accent/50 sm:block" data-id="element-199" data-mp="381nrczkpyaz7" />
        </p>

        <h1 className="mt-6 text-[2.1rem] font-extrabold uppercase leading-[0.98] tracking-tight text-white sm:text-6xl lg:text-[4.2rem]" data-id="element-200" data-mp="3j9ty8ric7ai4">
          Dominá tu iPhone
          <span className="mt-1 block text-accent-soft" data-id="element-201" data-mp="39aurjeh4toxr">de una vez por todas</span>
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-202" data-mp="3e8wjkowjcyld">
          El método paso a paso que convierte tu iPhone de{' '}
          <span className="text-white" data-id="element-203" data-mp="30fybc1yzvc0e">“solo lo básico”</span> a{' '}
          <span className="text-white" data-id="element-204" data-mp="359j6lm97drvw">dominarlo de verdad</span>: funciones
          ocultas, batería, seguridad, organización y cámara, aunque no sepas
          nada de tecnología.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      delay: 0.2,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mx-auto mt-12 w-full max-w-2xl" data-id="element-205" data-mp="2vj7uhcfd8cdx">
        <span className="absolute -top-3 right-4 z-10 rounded-full bg-accent px-4 py-2 text-[11px] font-bold uppercase tracking-wide text-white shadow-[0_8px_30px_-10px_rgba(10,132,255,0.9)]" data-id="element-206" data-mp="s2b89zesml5o">
          1 libro + 5 bonos
        </span>
        <img src="https://cdn.magicpatterns.com/uploads/t4AKBSPk9J146ZgvKMMEjG/ChatGPT_Image_27_jul_2026,_05_38_36_p.m..png" alt="Diccionario Apple: todo Apple en un solo lugar, con explicaciones claras, búsqueda rápida, funciones esenciales y para todos los niveles" className="w-full rounded-3xl border border-white/10 object-cover" data-id="element-207" data-mp="icrs51igt5ei" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.35,
      ease: [0.22, 1, 0.36, 1]
    }} className="relative mx-auto mt-10 w-full max-w-2xl" data-id="element-208" data-mp="1126ncfbgz0az">
        <CTAButton className="items-center" data-id="element-209" data-mp="3lquftrppid6n" />
      </motion.div>
    </header>;
}